export default __webpack_public_path__ + "static/media/bank-logo-amex.2a1c1340.png";